import React from "react";
import Page from "../../Components/Page";
import { Card, CardContent } from "@mui/material";

const DepositsC2BRecon = () => {
  return (
    <Page title={"Deposits/C2B Recon"}>
      <Card>
        <CardContent>
          <form></form>
        </CardContent>
      </Card>
    </Page>
  );
};

export default DepositsC2BRecon;
